import { ReserveStatus } from '../../../components/Listing/ListingContextSection';
import { APIListingItem } from '../types';

/**
 * Maps over an API Listing's auction status and whether the reserve has been met. Returns a value to use when indicating the state of the reserve in the listing card.
 */
export function mapReserveStatus({
  reservePriceMet,
  status,
}: APIListingItem): ReserveStatus {
  if (reservePriceMet) {
    return 'success';
  }

  switch (status) {
    case 'Unsold':
      return 'error';
    case 'Active':
    default:
      return 'default';
  }
}
